import axios from "axios";
import { clearAuthStorage, getToken } from "./auth/token";
import { refreshAccessToken } from "./auth/sessionRefresh";

let isRefreshing = false;

axios.interceptors.request.use((config) => {
    if (config.skipAuth) {
        config.headers["X-App-Locale"] = "ru_RU";
        return config;
    }
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["X-App-Locale"] = "ru_RU";
    return config;
});

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error?.config;
        if (!originalRequest) {
            return Promise.reject(error);
        }

        const status = error?.response?.status;
        if (originalRequest.skipAuth) {
            return Promise.reject(error);
        }
        if (status !== 401 || originalRequest._retry) {
            return Promise.reject(error);
        }
        if ((originalRequest.url || "").includes("/api/token/refresh")) {
            clearAuthStorage();
            window.dispatchEvent(new CustomEvent("auth:logout-required"));
            return Promise.reject(error);
        }

        originalRequest._retry = true;
        try {
            if (isRefreshing) {
                await refreshAccessToken();
            } else {
                isRefreshing = true;
                try {
                    await refreshAccessToken();
                } finally {
                    isRefreshing = false;
                }
            }
            const newToken = getToken();
            originalRequest.headers = {
                ...(originalRequest.headers || {}),
                Authorization: `Bearer ${newToken}`,
            };
            return axios(originalRequest);
        } catch (refreshError) {
            clearAuthStorage();
            window.dispatchEvent(new CustomEvent("auth:logout-required"));
            return Promise.reject(refreshError);
        }
    },
);
